import React from "react";
import { Container, Row, Col } from "react-bootstrap"; 
import "./Associate.css"; 
import AssociateImg from '../../../assets/ass. normal.jpg'
import { motion } from "framer-motion";

export default function Associate() {
  return (
    <div className="associateclass">
    <Container fluid className="py-5" style={{ minHeight: "100vh" }}>
      <Row style={{height:'80vh'}}>
        <Col lg={6} className="d-flex justify-content-center align-items-center ">
          <motion.div
            initial={{ opacity: 0, x: -100 }} 
            animate={{ opacity: 1, x: 0 }} 
            transition={{ duration: 1 }} 
          >
            <img
              src={AssociateImg}
              alt="Associate"
              className="img-fluid shadow-lg rounded"
            />
          </motion.div>
        </Col>

        <Col lg={6} className="d-flex flex-column justify-content-center">
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <h1>Shivek Associates</h1>
            <h2>Welcome to SHIVEK ASSOCIATES</h2>
            <p className="lead" style={{textAlign:'justify'}}>
            Welcome to SHIVEK ASSOCIATES, your trusted partner for business development
and financial solutions. With years of expertise in accounting, taxation, and business
formation, we provide tailored services to help your business thrive. Our team of
experienced professionals is committed to offering high-quality, reliable solutions to
businesses of all sizes.
            </p>
          </motion.div>
        </Col>
      </Row>

      <div className="my-5">
        <h2>Our Services</h2>
        <p>
          At SHIVEK ASSOCIATES, we offer a comprehensive range of services designed to support your business growth and ensure financial stability. Explore our services below:
        </p>

        <Row>
          <Col md={4}>
            <h4>Business Development Solutions</h4>
            <p>Helping your business grow with strategic planning, market analysis, and expert consulting.</p>
          </Col>
          
          <Col md={4}>
            <h4>Income Tax Return Filing for Companies</h4>
            <p>Accurate and timely income tax filing, ensuring compliance with all regulations and optimizing your tax position.</p>
          </Col>

          <Col md={4}>
            <h4>Tax Planning and Advisory</h4>
            <p>Expert guidance on tax strategies, helping your business minimize liabilities and maximize savings.</p>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <h4>GST Return Filing</h4>
            <p>Hassle-free GST filing services to ensure your business remains compliant with the latest tax laws.</p>
          </Col>

          <Col md={4}>
            <h4>Company Formation and Documentation</h4>
            <p>Building companies from scratch, managing all legal documentation, and ensuring smooth registration.</p>
          </Col>

          <Col md={4}>
            <h4>Accountancy Services</h4>
            <p>Comprehensive accounting services to keep your financial records accurate, transparent, and compliant.</p>
          </Col>
        </Row>
      </div>

    
    </Container>
    </div>
  );
}
